<template>
  <transition-group
    ref="messages" name="t-chat"
    tag="div" class="chat-messages py-3" appear
  >
    <component
      :is="toMessageComp(message)" v-for="message in messages"
      :key="message.id" :message="message" :user="user"
      class="chat-message"
      @inspect="onInspect($event, message)"
    />
  </transition-group>
</template>

<script>
import User from '@/store/models/user/User'
import { sleep } from '@/utils'

export default {
  components: {
    UserMessage: () => import('@/components/Chat/ChatUserMessage'),
    SystemMessage: () => import('@/components/Chat/ChatSystemMessage'),
  },
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
    user: {
      type: [User, Object],
      default: null,
    },
  },
  watch: {
    async messages() {
      const { $el: $messages } = this.$refs.messages
      if (!$messages) return

      await this.$nextTick()
      this.scrollToBottom($messages)
    },
  },
  async mounted() {
    const { $el: $messages } = this.$refs.messages

    await sleep(300) // wait for transition
    this.scrollToBottom($messages)
  },
  methods: {
    scrollToBottom(element) {
      const el = element
      el.scrollTop = el.scrollHeight
    },
    toMessageComp(message) {
      if (message.user) return 'user-message'
      return 'system-message'
    },
    onInspect(e, message) {
      if (!message.user) return

      this.$userMenu.open(e, { ...message.user, messageId: message.id, room: message.room })
    },
  },
}
</script>

<style lang="scss" scoped>
.chat-messages {
  overflow-x: hidden;
  overflow-y: auto; // fallback for Firefox
  overflow-y: overlay;
  min-height: 300px;
  will-change: scroll-position, transform;

  .chat-message {
    transition: transform 0.3s ease, opacity 0.3s ease;

    &:last-child {
      margin-bottom: 0 !important;
    }
  }
}

.t-chat {
  &-enter {
    opacity: 0;
    transform: translateX(-15%);
  }

  &-leave-to {
    position: absolute;
    opacity: 0;
  }

  &-enter-to {
    opacity: 1;
    transform: translateX(0);
  }
}

</style>
